﻿(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyExpandingField", [
    "$analytics",
    function ($analytics) {
      var actions = {
        EXPANDING_FIELD_OPEN: { analyticsEventAction: "open" },
        EXPANDING_FIELD_CLOSE: { analyticsEventAction: "close" },
      };

      var controller = [
        "$scope",
        function ($scope) {
          var ctl = this;

          ctl.state = {
            enableTransitions: false,
            isOpen: false,
            isTransitioning: false,
          };

          ctl.lastState = angular.copy(ctl.state);

          ctl.triggerAnalytics = function (action) {
            $analytics.eventTrack("gaClick", {
              eventCategory: ctl.eventCategory,
              eventAction: action.analyticsEventAction,
              eventLabel: ctl.eventLabel ? ctl.eventLabel : null,
            });
          };

          ctl.open = function () {
            $scope.$evalAsync(function () {
              ctl.state.isOpen = true;
            });
          };

          ctl.close = function () {
            $scope.$evalAsync(function () {
              ctl.state.isOpen = false;
            });
          };

          function init() {
            if (ctl.startOpen === "true") {
              ctl.state.isOpen = true;
            }
          }

          ctl.$onInit = init;
        },
      ];

      var link = function ($scope, $element, $attrs, $ctrl) {
        var $toggle = $element.find("[data-ty-expanding-field-toggle]");
        var $content = $element.find("[data-ty-expanding-field-content]");

        function repaint() {
          var enableTransitions = $ctrl.state.enableTransitions;

          var isOpenChanged = $ctrl.state.isOpen !== $ctrl.lastState.isOpen;
          var isTransitioningChanged = $ctrl.state.isTransitioning !== $ctrl.lastState.isTransitioning;

          var startOpening = isOpenChanged && $ctrl.state.isOpen;
          var startClosing = isOpenChanged && !$ctrl.state.isOpen;
          var finishOpening = isTransitioningChanged && $ctrl.state.isOpen && !$ctrl.state.isTransitioning;
          var finishClosing = isTransitioningChanged && !$ctrl.state.isOpen && !$ctrl.state.isTransitioning;

          if (enableTransitions) {
            if (startOpening) {
              $ctrl.state.isTransitioning = true;
              $content.stop().slideDown({
                complete: function () {
                  $ctrl.state.isTransitioning = false;
                  repaint();
                },
              });
            }

            if (startClosing) {
              $ctrl.state.isTransitioning = true;
              $content.stop().slideUp({
                complete: function () {
                  $ctrl.state.isTransitioning = false;
                  repaint();
                },
              });
            }
          }

          if ((enableTransitions && (finishOpening || finishClosing)) || !enableTransitions) {
            $toggle.toggleClass("open", $ctrl.state.isOpen);
            $content.css("display", $ctrl.state.isOpen ? "block" : "none");
          }

          $ctrl.lastState = angular.copy($ctrl.state);
        }

        $scope.$watch(
          "tyExpandingField.state",
          function (newState, oldState) {
            if (angular.equals(newState, oldState)) {
              return;
            }

            repaint();
          },
          true
        );

        $toggle.on("click", function () {
          var action = $ctrl.state.isOpen ? actions.EXPANDING_FIELD_CLOSE : actions.EXPANDING_FIELD_OPEN;

          if ($ctrl.eventCategory) {
            $ctrl.triggerAnalytics(action);
          }

          if (action === actions.EXPANDING_FIELD_OPEN) {
            $ctrl.open();
          }

          if (action === actions.EXPANDING_FIELD_CLOSE) {
            $ctrl.close();
          }
        });

        repaint();
        $ctrl.state.enableTransitions = true;
      };

      return {
        restrict: "A",
        scope: true,
        bindToController: {
          startOpen: "@tyExpandingFieldStartOpen",
          eventCategory: "@tyExpandingFieldAnalyticsEventCategory",
          eventLabel: "@tyExpandingFieldAnalyticsEventLabel",
        },
        controllerAs: "tyExpandingField",
        controller: controller,
        link: link,
      };
    },
  ]);
})(window.angular);
